import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Deep flatten including arrays
const flattenObject = (obj, parentKey = "", res = {}) => {
  for (const key in obj) {
    const propName = parentKey ? `${parentKey}_${key}` : key;

    if (Array.isArray(obj[key])) {
      obj[key].forEach((item, index) => {
        if (typeof item === "object" && item !== null) {
          flattenObject(item, `${propName}_${index}`, res);
        } else {
          res[`${propName}_${index}`] = item;
        }
      });
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      flattenObject(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
};

export const exportAnyJsonToExcel = ({
  data = [],
  filePrefix = "Export",
  sheetName = "Sheet1",
}) => {

  if (!Array.isArray(data) || data.length === 0) {
    console.warn("No data available to export");
    return;
  }

  const flatData = data.map(item => flattenObject(item));

  const worksheet = XLSX.utils.json_to_sheet(flatData, { skipHeader: false });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const dateStr = new Date()
    .toLocaleString("en-IN")
    .replace(/[\/,: ]/g, "_");

  const fileName = `${filePrefix}_${dateStr}.xlsx`;

  saveAs(blob, fileName);
};